.container {
    width: 400px;
    text-align: center;
}

.icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 5px 4px;
    border-radius: 100%;
    background-color: var(--green-lt);
    width: fit-content;
}
